module.exports = __webpack_public_path__ + "img/Cooperation.ade3b2c1.svg";